export const getTotalBackgroundLogos = (
  conteiner: HTMLElement,
  conteinerWidth = 0,
) => {
  const bgContainerHeight = conteiner.clientHeight;
  const bgContainerWidth = conteinerWidth || conteiner.clientWidth;

  const hoverLogoHeight = 110;
  const hoverLogoWidth = 120;

  const totalLogoInRow = Math.ceil(bgContainerWidth / hoverLogoWidth);
  const totalLogoInColumn = Math.ceil(bgContainerHeight / hoverLogoHeight);
  const totalLogos = totalLogoInRow * totalLogoInColumn;

  const images = [];

  for (let i = 1; i <= totalLogos; i++) {
    images.push(i);
  }

  return images;
};
